import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import logger from "../logger";
import ImageLoader from "./ImageLoader";

const CartItem = ({ item, onDeleteItem = null }) => {
  const [body, setBody] = useState({});

  useEffect(() => {
    if (item) {
      if (typeof item.body === "string") {
        try {
          setBody(JSON.parse(item.body));
        } catch (err) {
          logger("CartItem.item.body.rds.error", err);
        }
      } else {
        setBody(item.body);
      }
    }
  }, [item]);

  if (!item) return null;

  return (
    <ListItem className="cart-item">
      <ListItemAvatar>
        <Avatar variant="rounded">
          {item.product.medias && item.product.medias.length > 0 && (
            <ImageLoader
              className="cart-productImg"
              imgKey={item.product.medias[0] && item.product.medias[0].key}
              alt={item.product.name}
              circularProgressSize={20}
              thumb
            />
          )}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={item.product.name}
        secondary={
          <>
            {((body || {}).features || []).length > 0 && (
              <>
                {body.features.map((f, i) => (
                  <span key={`f-${item.product.id}-${i}`}>
                    {f.label} {f.option.label}
                    {i < body.features.length - 1 && ", "}
                  </span>
                ))}
                <br />
              </>
            )}
            <span>
              {item.quantity === 1 ? (
                <NumberFormat
                  value={item.total}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix="$"
                  displayType={"text"}
                />
              ) : (
                <>
                  <NumberFormat
                    value={item.total}
                    thousandSeparator="."
                    decimalSeparator=","
                    prefix="$"
                    displayType={"text"}
                  />
                  {" ("}
                  <NumberFormat
                    value={item.price}
                    thousandSeparator="."
                    decimalSeparator=","
                    prefix="$"
                    displayType={"text"}
                  />
                  {" x "}
                  {item.quantity}
                  {")"}
                </>
              )}
            </span>
          </>
        }
      />
      {onDeleteItem && (
        <ListItemSecondaryAction>
          <IconButton edge="end" aria-label="delete" onClick={() => onDeleteItem(item)}>
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};

export default CartItem;
